import React, { FC } from 'react';

import { ErrorBoundary } from 'react-error-boundary';

import { report } from '@adsk/exo-skeleton-api';

import HttpErrorState from './HttpErrorState';
import i18n from '../helpers/i18n';

export const ProjectListErrorBoundery: FC = ({ children }) => {
  return (
    <ErrorBoundary
      fallbackRender={() => (
        <HttpErrorState errorMessage={i18n.t('SOMETHING_WENT_WRONG')} />
      )}
      onError={async (err) => {
        await report({
          type: 'error',
          value: err,
          scope: 'accProjectList',
          context: {
            scope: 'accProjectList',
          },
        });
      }}
    >
      {children}
    </ErrorBoundary>
  );
};
